import React from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../../Themes';

import styles from './ChoosePlanSection.Styles';

const ChoosePlanSection = ({
  withWhyThisPlan,
  onSelectPlanPress,
  withChoosePlan,
  onWhyThisPlanPress,
  whyThisPlanKey,
  choosePlanKey,
  whyThisPlanStyle,
  choosePlanButtonType,
  choosePlanButtonTextStyle,
}) => {
  const theme = useTheme();
  const Images = getThemeImages(theme.name);
  return (
    <View style={styles.choosePlanContainer(theme)}>
      {withWhyThisPlan && (
        <TouchableWithoutFeedback onPress={onWhyThisPlanPress}>
          <View style={styles.whyThisPlanContainer}>
            <VFText
              style={[styles.whyThisPlanText(theme), whyThisPlanStyle]}
              i18nKey={whyThisPlanKey}
            />
            <Icon name={Images.icInfoCircle} type="image" style={styles.whyThisPlanIcon} />
          </View>
        </TouchableWithoutFeedback>
      )}
      {withChoosePlan && (
        <VFButton
          type={choosePlanButtonType || 'tertiary'}
          style={styles.choosePlanButton}
          textStyle={choosePlanButtonTextStyle}
          title={choosePlanKey}
          onPress={onSelectPlanPress}
        />
      )}
    </View>
  );
};

ChoosePlanSection.defaultProps = {
  withChoosePlan: true,
  withWhyThisPlan: true,
  onSectionContainerLayout: () => {},
  onSelectPlanPress: () => {},
  onWhyThisPlanPress: () => {},
};
ChoosePlanSection.propTypes = {
  choosePlanKey: PropTypes.string,
  whyThisPlanKey: PropTypes.string,
  withChoosePlan: PropTypes.bool,
  withWhyThisPlan: PropTypes.bool,
  onSelectPlanPress: PropTypes.func,
  onWhyThisPlanPress: PropTypes.func,
  whyThisPlanStyle: PropTypes.object,
  choosePlanButtonType: PropTypes.string,
  choosePlanButtonTextStyle: PropTypes.object,
};

export default ChoosePlanSection;
